import { createFileRoute } from '@tanstack/react-router';

import { SecretaryAccessPage } from '@/features/secretary/SecretaryPages.js';

export const Route = createFileRoute('/secretary/access')({
  component: SecretaryAccessPage,
});
